
/* ==========================================================================
   KINOVA — Sayt bo'ylab umumiy xatti-harakatlar
   Header/footer inject qilish, mobile drawer, scroll effektlari,
   reveal-on-scroll animatsiyasi, kichik yordamchi util funksiyalar.
   ========================================================================== */

(function () {
  var KUtil = {
    qs: function (name, fallback) {
      var params = new URLSearchParams(window.location.search);
      var v = params.get(name);
      return v === null ? (fallback === undefined ? null : fallback) : v;
    },
    debounce: function (fn, wait) {
      var t;
      return function () {
        var args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    },
    clamp: function (n, min, max) { return Math.max(min, Math.min(max, n)); }
  };
  window.KUtil = KUtil;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function injectChrome() {
    var headerRoot = document.getElementById('site-header-root');
    var footerRoot = document.getElementById('site-footer-root');
    var page = document.body.getAttribute('data-page') || '';
    if (headerRoot) headerRoot.innerHTML = KC.header(page);
    if (footerRoot) footerRoot.innerHTML = KC.footer();
    if (headerRoot && !document.getElementById('mobileDrawer')) {
      document.body.insertAdjacentHTML('beforeend', KC.mobileMenu());
    }
  }

  function wireHeaderScroll() {
    var header = document.getElementById('siteHeader');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 10) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function wireMobileDrawer() {
    var burger = document.getElementById('burgerBtn');
    var searchToggle = document.getElementById('searchToggleMobile');
    var drawer = document.getElementById('mobileDrawer');
    if (!drawer) return;
    var overlay = document.getElementById('mobileDrawerOverlay');
    var closeBtn = document.getElementById('mobileDrawerClose');

    function open(focusSearch) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      if (focusSearch) {
        var input = drawer.querySelector('.mobile-drawer__search input');
        if (input) setTimeout(function () { input.focus(); }, 260);
      }
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    }
    if (burger) burger.addEventListener('click', function () { open(false); });
    if (searchToggle) searchToggle.addEventListener('click', function () { open(true); });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function wireRowArrows() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.row-arrow') : null;
      if (!btn) return;
      var target = document.getElementById(btn.getAttribute('data-scroll-target'));
      if (!target) return;
      var dir = parseInt(btn.getAttribute('data-dir'), 10);
      target.scrollBy({ left: dir * Math.round(target.clientWidth * 0.85), behavior: 'smooth' });
    });
  }

  function wireReveal() {
    var els = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window) || !els.length) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }
  window.KRefreshReveal = wireReveal;

  /* Generic icon-slot painter: any static HTML element written as
     <span data-icon="mail" data-size="18"></span> gets its SVG filled in.
     Lets plain markup (forms, static page furniture) use the icon set
     without every page needing bespoke JS just to draw an icon. */
  function paintIconSlots(scope) {
    var nodes = (scope || document).querySelectorAll('[data-icon]');
    nodes.forEach(function (el) {
      var name = el.getAttribute('data-icon');
      var size = parseInt(el.getAttribute('data-size') || '18', 10);
      if (window.Icon && window.Icon[name]) el.innerHTML = window.Icon[name](size);
    });
  }
  window.KPaintIcons = paintIconSlots;

  /* Bosqich 4 — parol maydonlari uchun ko'rsatish/yashirish tugmasi.
     Generic (event delegation): `<button data-password-toggle="password">`
     shu id'li input turini almashtiradi. Har bir auth sahifasi (login/
     register/profil) uchun alohida JS talab qilmaydi — bitta joyda. */
  function wirePasswordToggles() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-password-toggle]') : null;
      if (!btn) return;
      var input = document.getElementById(btn.getAttribute('data-password-toggle'));
      if (!input) return;
      var willShow = input.type === 'password';
      input.type = willShow ? 'text' : 'password';
      if (window.Icon) {
        var icon = window.Icon[willShow ? 'eyeOff' : 'eye'];
        if (icon) btn.innerHTML = icon(16);
      }
      btn.setAttribute('aria-label', willShow ? 'Parolni yashirish' : 'Parolni ko\'rsatish');
    });
  }


  /* ==========================================================================
     19-bosqich — LOGOTIP TO'LQINI (admin paneldan boshqariladi)

     Sozlama: `brand.logo_interval` (soniya). 0 — harakat o'chadi.
     Qiymat CSS o'zgaruvchisiga yoziladi, qolganini patches.css qiladi.

     ⚠️ Chegara 3..60 soniya: tasodifan 1 qo'yilsa logotip tinmay
        miltillab, o'qishga xalaqit berardi.
     ========================================================================== */
  function applyLogoMotion() {
    var settings = (window.KDATA && window.KDATA.SETTINGS) || {};
    var raw = parseInt(settings['brand.logo_interval'], 10);
    var sec = isNaN(raw) ? 9 : raw;
    var root = document.documentElement;

    if (sec <= 0) {
      root.setAttribute('data-logo-motion', 'off');
      return;
    }

    sec = Math.min(60, Math.max(3, sec));
    root.setAttribute('data-logo-motion', 'on');
    root.style.setProperty('--kinova-logo-interval', sec + 's');
  }

  ready(function () {
    injectChrome();
    applyLogoMotion();
    wireHeaderScroll();
    wireMobileDrawer();
    wireRowArrows();
    wirePasswordToggles();
    paintIconSlots();
    setTimeout(wireReveal, 30);
  });
})();

